//=================================//
//    SHUFFLED INK | NAVIGATION    //
//=================================//

(function($) {
	$(document).ready(function() {

		// set our things
		var header		= $( 'header[role=banner]' );
		var topStrip	= $( '#top-strip' );
		var titleBar	= $( '.title-bar' );
		var topBar		= $( '.top-bar' );
		var adminBar	= $( '#wpadminbar' );


		/**
		 * MOBILE NAV TOGGLE
		 */
		$( header, '#toggle-menu' ).click( function() {

			// if the mobile menu is open & there is an open submenu
			if ( ( header.hasClass( 'mobile-menu-open' ) ) && ( $( '.is-accordion-submenu' ).attr( 'aria-hidden' ) == 'false' ) ) {
				$( '.is-accordion-submenu-parent' ).attr( 'aria-selected', 'false' );
				$( '.is-accordion-submenu-parent' ).attr( 'aria-expanded', 'false' );
				$( '.is-accordion-submenu' ).toggle();
				$( '.is-accordion-submenu' ).attr( 'aria-hidden', 'true' );
			}

			// toggle Menu Open
			header.toggleClass( 'mobile-menu-open' );

			// set title bar offset for top bar
			if ( header.hasClass( 'mobile-menu-open' ) ) {

				if ( titleBar.hasClass( 'fixed' ) ) {
					titlebarHeight = titleBar.outerHeight() + adminBar.outerHeight();
				} else {
					var titlebarHeight = titleBar.outerHeight() + adminBar.outerHeight() + topStrip.outerHeight();
				}
				
				topBar.css({ top: titlebarHeight });

			} else {
				var topbarHeight = topBar.outerHeight();
				topBar.css({ top: -topbarHeight });
			}

		}); // menu toggle click fn



		/**
		 * MOBILE MENU OFFSET
		 */
		function doMenuOffset() {
			var topbarHeight	= topBar.outerHeight() + topStrip.outerHeight();
			var titlebarHeight	= titleBar.outerHeight() + topStrip.outerHeight();

			topBar.css({ top: -(topbarHeight + titlebarHeight) });
		}

		// run on load
		doMenuOffset();

		// run on width change
		$( window ).resize( function() {
			doMenuOffset();
		});



		/**
		 * FANCY TRANSFORMING HAMBURGER
		 */
		var toggles = document.querySelectorAll( ".c-hamburger" );

		for ( var i = toggles.length - 1; i >= 0; i-- ) {
			var toggle = toggles[i];
			toggleHandler( toggle );
		}

		function toggleHandler( toggle ) {
			toggle.addEventListener( "click", function(e) {
				e.preventDefault();
				( this.classList.contains( "is-active" ) === true ) ? this.classList.remove( "is-active" ) : this.classList.add( "is-active" );
			});
		}



		/**
		 * STICKY TITLE/TOP BAR ON SCROLL
		 */
		$(window).scroll( function() {

			// set our scroll watcher and heights
			var scroll			= $(window).scrollTop();
			var titlebarHeight	= titleBar.outerHeight();
			var topStripHeight	= topStrip.outerHeight();
			var adminBarHeight	= adminBar.outerHeight();


			/**
			 * Check for top strip
			 */
			if ( topStripHeight > 0 ) {

				// if scrolled past top strip, fix the title bar & top bar
				if ( scroll >= topStripHeight ) {

					titleBar.addClass( 'fixed' );
					topBar.addClass( 'fixed' );
					$( '#inner-content' ).addClass( 'title-bar-fixed' );

					// make sure mobile menu offset is correct
					if ( header.hasClass( 'mobile-menu-open' ) ) {
						topBar.css({ top: titlebarHeight + adminBarHeight });
					}
				}

				// if scrolled back up to top strip
				if ( scroll >= 0 && scroll < topStripHeight ) {

					titleBar.removeClass( 'fixed' );
					topBar.removeClass( 'fixed' );
					$( '#inner-content' ).removeClass( 'title-bar-fixed' );

					// set mobile menu back to "absolute native" top
					if ( header.hasClass( 'mobile-menu-open' ) ) {
						topBar.css({ top: 'auto' });
					}	
				}
			} // top strip exists


			// no top strip: immediately fix.
			else {
				titleBar.addClass( 'fixed' );
				topBar.addClass( 'fixed' );
				$( '#inner-content' ).addClass( 'title-bar-fixed' );
			}
		});


	}); // document.ready
})(jQuery);
